import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import NavbarComponent from '../../components/NavbarComponent';
import FooterComponent from '../../components/FooterComponent';
import styled, { keyframes } from 'styled-components';

// Define bounce animation
const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

// Styled components
const MessageContainer = styled.div`
  text-align: center;
  margin-top: 50px;
`;

const Logo = styled.img`
  height: 120px;
  animation: ${bounce} 1.5s infinite ease-in-out;
`;

const MessageText = styled.p`
  font-size: 20px;
  font-weight: bold;
  color: #232830; // Fintorro Orange
  margin-top: 15px;
`;

const ContinueButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  padding: 12px 30px;
  margin-top: 20px;
  width: 100%;
`;

const GetReadySkillTest = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    // ✅ Navigate to onboarding skill test instead of first lesson
    navigate('/onboarding-skill-test-new');
  };

  return (
    <>
      <NavbarComponent />

      <Container className="text-center my-5">
        <MessageContainer>
          {/* ✅ Animated Fintorro Logo */}
          <div className="my-4">
            <Logo src="/assets/fintorro-logo.png" alt="Fintorro Logo" />
          </div>

          {/* ✅ Updated Message Text in Orange */}
          <MessageText>Get ready. We will use this test to determine your skill level</MessageText>

          {/* ✅ Standardized Continue Button */}
          <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
        </MessageContainer>
      </Container>

      <FooterComponent />
    </>
  );
};

export default GetReadySkillTest;
